<div class="toaster">
  <div>
    @if (toastType == 'toast-success') {
      <mat-icon class="color-ind-green">check_circle</mat-icon>
    }
    @if (toastType == 'toast-error') {
      <mat-icon class="color-ind-red">error</mat-icon>
    }
  </div>
  <div class="toast-details">
    <div>
      @if (title) {
        <div [class]="options.titleClass" [attr.aria-label]="title" class="custom-title">
          {{ title }}.
        </div>
      }
      @if (message && options.enableHtml) {
        <div role="alert" aria-live="polite" class="custom-message"
          [class]="options.messageClass" [innerHTML]="message">
        </div>
      }
      @if (message && !options.enableHtml) {
        <div role="alert" aria-live="polite" class="custom-message"
          [class]="options.messageClass" [attr.aria-label]="message">
          {{ message }}
        </div>
      }
    </div>
  </div>
  <div>
    <div class="toast-close-button-container" (click)="remove()">
      @if (options.closeButton) {
        <mat-icon>close</mat-icon>
      }
    </div>
  </div>
</div>